/**
 * GraphQL `MediaKind` — PHP case names (`MATCH_ANNOUNCE`), not backed values
 * (`match_announce`). Stable identifiers: add, never rename.
 */
export enum MediaKind {
  MATCH_ANNOUNCE = 'MATCH_ANNOUNCE',
  MATCHES_ANNOUNCE = 'MATCHES_ANNOUNCE',
  MATCH_RESULT = 'MATCH_RESULT',
  MATCHES_RESULT = 'MATCHES_RESULT',
  CHAMPIONSHIP_TABLE = 'CHAMPIONSHIP_TABLE',
  GROUP_TABLE = 'GROUP_TABLE',
  TOP_SCORER = 'TOP_SCORER',
  TOUR_SCORERS = 'TOUR_SCORERS',
  PLAYOFF_BRACKET = 'PLAYOFF_BRACKET',
  BIRTHDAY = 'BIRTHDAY',
  TOUR_SYMBOLIC_TEAM = 'TOUR_SYMBOLIC_TEAM',
  CHAMPIONSHIP_SYMBOLIC_TEAM = 'CHAMPIONSHIP_SYMBOLIC_TEAM',
}

const KNOWN_KINDS: ReadonlySet<string> = new Set(Object.values(MediaKind));

export function isKnownMediaKind(value: string | undefined | null): value is MediaKind {
  return typeof value === 'string' && KNOWN_KINDS.has(value);
}

export const DEFAULT_MEDIA_KIND: MediaKind = MediaKind.MATCH_ANNOUNCE;

export const ALL_MEDIA_KINDS: readonly MediaKind[] = Object.values(MediaKind);

/** Kinds that exist in the catalog but are not generated yet (`supported: false`). */
export const UNSUPPORTED_MEDIA_KINDS: readonly MediaKind[] = [
  MediaKind.PLAYOFF_BRACKET,
  MediaKind.BIRTHDAY,
  MediaKind.TOUR_SYMBOLIC_TEAM,
  MediaKind.CHAMPIONSHIP_SYMBOLIC_TEAM,
];
